export const CAPI = {
    'DEV': 'https://c-api-dev.niushibang.net',
    'TEST': 'https://c-api-test.niushibang.net',
    'RELEASE': 'https://c-api.niushibang.net'
};
export const PUBLIC_KEY = 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBANfs/A0+UNNoswYZ5++yVvLyhdw0FbRXSZK3aP79eT5c5KfHR0nS77QzVO5e4OhxIW+iQ1BV2AvcALbT/SjTEPECAwEAAQ==';
